import * as React from 'react';
import { useState } from 'react';
import { fieldValidation } from '../../amorg-common';
import { Button } from '../../designSystem/button/Button';
import { Flex } from '../../designSystem/compositeComponents/FlexHelpers';
import { ButtonRow } from '../../designSystem/button/ButtonRow';
import { deleteLocation, updateLocation } from '../../api/locationClientApi';
import { Location as AmorgLocation} from '../../amorg-common';
import { MessageCard } from '../../designSystem/Message';
import { TextSaveField } from '../../designSystem/formField/text/TextSaveField';


type LocationEditorProps = {
    location:AmorgLocation,
    onLocationUpdated: () => void
    onClose: () => void
}

export function LocationEditor(props:LocationEditorProps):JSX.Element
{
    const [errorOnDeleteLocation, setErrorOnDeleteLocation] = useState(false);
    async function handleDeleteClick(){
        const result = await deleteLocation(props.location.id)
        
        if( !result.isSuccess){
            setErrorOnDeleteLocation(true);
        }

        if( result.isSuccess){
            props.onLocationUpdated()
        } 
    }

    async function handleUpdate(location:AmorgLocation)
    {
        await updateLocation(
            location.id,
            location.name,
            location.country,
            location.address,
            location.postalCode,
            location.city
        );
    }


    return (
        
        <Flex gap={24} flexDirection="column">
            
            <TextSaveField 
                label={"Navn*"}
                value={props.location.name}
                validator={(value) => fieldValidation.location.name(value) ? {valid:true} : {valid:false, errorMessage:"Skal udfyldes. Maks. 100 tegn"}}
                onSave={ async (value, isValid) => {
                    if(isValid && value !== props.location.name)
                    {
                        await handleUpdate({...props.location, name:value});
                        props.onLocationUpdated();
                    }
                }} />

            <TextSaveField 
                label={"Land*"}
                value={props.location.country}
                validator={(value) => fieldValidation.location.country(value) ? {valid:true} : {valid:false, errorMessage:"Maks. 100 tegn"}}
                onSave={ async (value, isValid) => {
                    if(isValid && value !== props.location.country){
                        await handleUpdate({...props.location, country:value});
                        props.onLocationUpdated();
                    }
                }} />
            
            <TextSaveField 
                label={"Adresse*"}
                value={props.location.address}
                validator={(value) => fieldValidation.location.address(value) ? {valid:true} : {valid:false, errorMessage:"Maks. 200 tegn"}}
                onSave={ async (value, isValid) => {
                    if(isValid && value !== props.location.address){
                        await handleUpdate({...props.location, address:value});
                        props.onLocationUpdated();
                    }
                }} />
            
            <TextSaveField 
                label={"By*"}
                value={props.location.city}
                validator={(value) => fieldValidation.location.city(value) ? {valid:true} : {valid:false, errorMessage:"Maks. 100 tegn"}}
                onSave={ async (value, isValid) => {
                    if(isValid && value !== props.location.city){
                        await handleUpdate({...props.location, city:value});
                        props.onLocationUpdated();
                    }
                }} />


            <TextSaveField 
                label={"Postnummer*"}
                value={props.location.postalCode} 
                validator={(value) => fieldValidation.location.postalCode(value) ? {valid:true} : {valid:false, errorMessage:"Maks. 20 tegn"}}
                onSave={ async (value, isValid) => {
                    if(isValid && value !== props.location.postalCode){
                        await handleUpdate({...props.location, postalCode:value});
                        props.onLocationUpdated();
                    }
                }} />
            

            {errorOnDeleteLocation &&
                <MessageCard variant="error">
                    Lokationen kan ikke slettes, da den er tilknyttet faciliteter
                </MessageCard>
            }

            <ButtonRow variant="space-between">
                
                <Button variant="destructive-text"
                        onClick={handleDeleteClick}
                        icon="interface_actions_delete"
                        text="Slet" />

                <Button
                    text="Luk"
                    variant='filled' 
                    icon="actions_done"
                    onClick={ props.onClose }
                    />
            </ButtonRow>
        </Flex>
    );
}